import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '../data';

type Param = {
  file: File;
};

type Return = boolean;

export const uploadCsv = withLogger(async (props: Param): Promise<Return> => {
  const url = usersAPIUrls.uploadCSV;

  const formData = new FormData();
  formData.append('file', props.file);

  await authAxiosClient.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return true;
});
